
export class UserLogin {
 "UserName": string;
 "FirstName": string;
 "MiddleNAme": string;
 "LastName": string;
 "MobileNo": string;
 "Email": string;
 "Password": string;
 
}
